import { render } from "./CardProductionBoxComponent.vue?vue&type=template&id=38dbd975&ts=true"
import script from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts"
export * from "./CardProductionBoxComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__